import { t } from '../../i18n/index.js';
import type { FlagStage } from './stage-order.js';

/**
 * A stage, in words.
 *
 * Written as five LITERAL calls rather than `t(`flags.stage.${stage}`)`, which
 * is what this was first and what the house rule forbids: a key built from a
 * variable is invisible to the unused-message detector, so deleting one of
 * these from the dictionary would break the screen with nothing to warn about
 * it.
 *
 * A record and not a switch, so adding a stage is a type error here rather than
 * a stage that silently renders as undefined.
 */
export function stageLabel(stage: FlagStage): string {
  const LABELS: Record<FlagStage, string> = {
    off: t('flags.stage.off'),
    internal: t('flags.stage.internal'),
    alpha: t('flags.stage.alpha'),
    beta: t('flags.stage.beta'),
    general: t('flags.stage.general'),
  };
  return LABELS[stage];
}
